import { render, staticRenderFns } from "./AwardSelectionRuleModal.vue?vue&type=template&id=3864ce58&scoped=true&"
import script from "./AwardSelectionRuleModal.vue?vue&type=script&lang=js&"
export * from "./AwardSelectionRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3864ce58",
  null
  
)

export default component.exports